import { DiscountType } from "types/DiscountType";

const DISCOUNT_KEY = "appliedDiscount";

export const saveDiscountToStorage = (discount: DiscountType): void => {
  try {
    sessionStorage.setItem(DISCOUNT_KEY, JSON.stringify(discount));
  } catch (error) {
    console.error("Error saving discount to storage:", error);
  }
};

export const getDiscountFromStorage = (): DiscountType | null => {
  try {
    const saved = sessionStorage.getItem(DISCOUNT_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error("Error reading discount from storage:", error);
    return null;
  }
};

export const clearDiscountFromStorage = (): void => {
  try {
    sessionStorage.removeItem(DISCOUNT_KEY);
  } catch (error) {
    console.error("Error clearing discount from storage:", error);
  }
};
